import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SeatMap from '../components/SeatMap';
import { useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL;

const HostelSeatMap = () => {
  const [seatData, setSeatData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchHostelBeds = async () => {
      try {
        const res = await axios.get(`${API}hostel/beds/live-map/`);
        setSeatData(res.data);
      } catch (err) {
        console.error('Error fetching hostel beds:', err);
      }
    };

    fetchHostelBeds();
  }, []);

  const handleSeatClick = (bed) => {
    navigate(`/hostel/book/${bed.id}`);
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>🏫 Hostel Live Beds</h2>
      <SeatMap data={seatData} onSeatClick={handleSeatClick} />
    </div>
  );
};

export default HostelSeatMap;
